document.addEventListener('DOMContentLoaded', function() {
  // ========================
  // 1. ALL PRODUCTS DROPDOWN: HOVER TO OPEN, CLICK TO NAVIGATE
  // ========================
  const allProductsDropdown = document.querySelector('.mega-dropdown');
  const allProductsToggle = document.querySelector('.mega-dropdown-toggle');
  
  if (allProductsDropdown && allProductsToggle) {
    // Hover to open dropdown
    allProductsDropdown.addEventListener('mouseenter', function() {
      this.classList.add('active');
    });
    
    // Keep dropdown open when hovering over the menu content
    const dropdownMenu = allProductsDropdown.querySelector('.mega-dropdown-menu');
    if (dropdownMenu) {
      dropdownMenu.addEventListener('mouseenter', function() {
        allProductsDropdown.classList.add('active');
      });
      dropdownMenu.addEventListener('mouseleave', function() {
        allProductsDropdown.classList.remove('active');
      });
    }
    
    // Close dropdown when mouse leaves both button and menu
    allProductsDropdown.addEventListener('mouseleave', function(e) {
      // Check if mouse is moving to the dropdown menu
      const relatedTarget = e.relatedTarget;
      if (!dropdownMenu.contains(relatedTarget)) {
        this.classList.remove('active');
      }
    });
    
    // Click on the "All Products" link should navigate to the all products page
    allProductsToggle.addEventListener('click', function(e) {
      // Navigate to the href of the link
      const href = this.getAttribute('href');
      if (href) {
        window.location.href = href;
      }
    });
  }
  
  // ========================
  // 2. COLLECTION DROPDOWN: HOVER TO OPEN, CLICK TO NAVIGATE
  // ========================
  const collectionWrapper = document.querySelector('.menu-wrapper[data-collection-menu="true"]');
  const collectionButton = collectionWrapper ? collectionWrapper.querySelector('.menu-button') : null;
  
  if (collectionWrapper && collectionButton) {
    // Hover to open dropdown
    collectionWrapper.addEventListener('mouseenter', function() {
      this.classList.add('active');
    });
    
    // Keep dropdown open when hovering over the dropdown content
    const dropdownContent = collectionWrapper.querySelector('.dropdown');
    if (dropdownContent) {
      dropdownContent.addEventListener('mouseenter', function() {
        collectionWrapper.classList.add('active');
      });
      dropdownContent.addEventListener('mouseleave', function() {
        collectionWrapper.classList.remove('active');
      });
    }
    
    // Close dropdown when mouse leaves wrapper
    collectionWrapper.addEventListener('mouseleave', function(e) {
      const relatedTarget = e.relatedTarget;
      if (!dropdownContent.contains(relatedTarget)) {
        this.classList.remove('active');
      }
    });
    
    // Click on "Collection" should navigate to the main collections page
    collectionButton.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href) {
        window.location.href = href;
      }
    });
  }
  
  // ========================
  // 3. COLLECTION TABS: HOVER SHOWS PREVIEW, CLICK NAVIGATES
  // ========================
  const collectionTabs = document.querySelectorAll('[data-collection-menu="true"] .dropdown-left div');
  const collectionViewAllButton = document.querySelector('[data-collection-menu="true"] .view-all-button');
  
  collectionTabs.forEach(tab => {
    const collectionUrl = tab.getAttribute('data-collection-url');
    
    // Click on tab name navigates to collection
    if (collectionUrl) {
      tab.addEventListener('click', function(e) {
        window.location.href = collectionUrl;
      });
    }
    
    // Hover to show preview images
    tab.addEventListener('mouseenter', function(e) {
      const target = tab.getAttribute('data-tab');
      if (!target) return;
      
      // Update active tab styling
      collectionTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      
      // Update heading
      const heading = document.getElementById('activeHeading');
      if (heading) heading.textContent = tab.textContent;
      
      // Update view all button link
      if (collectionViewAllButton && collectionUrl) {
        collectionViewAllButton.href = collectionUrl;
      }
      
      // Show corresponding images
      const imageSets = document.querySelectorAll('[data-collection-menu="true"] .image-set');
      imageSets.forEach(set => set.classList.remove('active'));
      const activeSet = document.querySelector(`[data-collection-menu="true"] .image-set.${target}`);
      if (activeSet) {
        setTimeout(() => activeSet.classList.add('active'), 10);
      }
    });
  });
  
  // ========================
  // 4. SUBMENU BEHAVIOR: HOVER TO SHOW, CLICK ON MAIN LINK NAVIGATES
  // ========================
  // Submenus are handled by CSS hover - no JS needed for showing/hiding
  // Ensure that clicking on a mega-has-submenu link navigates normally
  const submenuLinks = document.querySelectorAll('.mega-has-submenu');
  submenuLinks.forEach(link => {
    // Remove any existing click handlers that might interfere
    // Let the browser handle the navigation normally
    link.addEventListener('click', function(e) {
      // Allow default navigation - do not prevent default
      return true;
    });
  });
  
  // ========================
  // 5. CLOSE DROPDOWNS WHEN CLICKING OUTSIDE
  // ========================
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.mega-dropdown') && !e.target.closest('[data-collection-menu="true"]')) {
      document.querySelectorAll('.mega-dropdown, [data-collection-menu="true"]').forEach(d => {
        d.classList.remove('active');
      });
    }
  });
  
  // ========================
  // 6. NEW BADGE ANIMATION
  // ========================
  const newBadgeWrappers = document.querySelectorAll('.mega-new-badge-wrapper');
  function animateBadges() {
    newBadgeWrappers.forEach(wrapper => {
      if (wrapper.getAttribute('data-blinking') === 'true') {
        if (wrapper.style.transform === 'scale(1.1)') {
          wrapper.style.transform = 'scale(1)';
          wrapper.style.opacity = '0.8';
        } else {
          wrapper.style.transform = 'scale(1.1)';
          wrapper.style.opacity = '1';
        }
      }
    });
  }
  setInterval(animateBadges, 700);
  
  // ========================
  // 7. FIX Z-INDEX FOR DROPDOWNS
  // ========================
  const megaDropdowns = document.querySelectorAll('.mega-dropdown, .menu-wrapper');
  megaDropdowns.forEach((dropdown, index) => {
    dropdown.style.zIndex = 100 - index;
  });
  
  // ========================
  // 8. ADJUST SUBMENU POSITION FOR LAST COLUMN
  // ========================
  function updateSubmenuPositions() {
    const menuCols = document.querySelectorAll('.mega-menu-col');
    menuCols.forEach((col, index) => {
      const submenus = col.querySelectorAll('.mega-submenu');
      const row = col.parentElement;
      const colsInRow = row.querySelectorAll('.mega-menu-col');
      const isLastInRow = (index + 1) % colsInRow.length === 0 || index === colsInRow.length - 1;
      const rect = col.getBoundingClientRect();
      const rowRect = row.getBoundingClientRect();
      const isLastByPosition = rect.right + 20 >= rowRect.right;
      
      submenus.forEach(submenu => {
        if (isLastInRow || isLastByPosition) {
          submenu.classList.add('mega-submenu-left');
        } else {
          submenu.classList.remove('mega-submenu-left');
        }
      });
    });
  }
  
  window.addEventListener('resize', updateSubmenuPositions);
  updateSubmenuPositions();
  
  // Force all submenus in the last column to open to the left
  document.querySelectorAll('.mega-menu-row').forEach(row => {
    const columns = row.querySelectorAll('.mega-menu-col');
    const lastColumn = columns[columns.length - 1];
    if (lastColumn) {
      const submenus = lastColumn.querySelectorAll('.mega-submenu');
      submenus.forEach(submenu => {
        submenu.classList.add('mega-submenu-left');
      });
    }
  });
  
  // Adjust submenu position on hover based on viewport
  document.querySelectorAll('.mega-submenu-parent').forEach(parent => {
    parent.addEventListener('mouseenter', function() {
      const submenu = this.querySelector('.mega-submenu');
      if (submenu) {
        const rect = this.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        if (rect.right + submenu.offsetWidth > viewportWidth) {
          submenu.classList.add('mega-submenu-left');
        } else {
          submenu.classList.remove('mega-submenu-left');
        }
      }
    });
  });
  
  // Ensure third-level menus also position correctly
  document.querySelectorAll('.mega-third-level-parent').forEach(parent => {
    parent.addEventListener('mouseenter', function() {
      const thirdMenu = this.querySelector('.mega-third-level-menu');
      if (thirdMenu) {
        const rect = this.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        if (rect.right + thirdMenu.offsetWidth > viewportWidth) {
          thirdMenu.style.left = 'auto';
          thirdMenu.style.right = '100%';
        } else {
          thirdMenu.style.left = '100%';
          thirdMenu.style.right = 'auto';
        }
      }
    });
  });
  
  // ========================
  // 9. ACTIVE MENU ITEM HIGHLIGHTING
  // ========================
  document.querySelectorAll('.mega-menu-item:not(.mega-dropdown-toggle):not(.menu-button)').forEach(item => {
    item.addEventListener('click', function() {
      document.querySelectorAll('.mega-menu-item').forEach(i => {
        i.classList.remove('active');
      });
      this.classList.add('active');
      localStorage.setItem('activeMegaMenuItem', this.href);
    });
  });
  
  const activeItemHref = localStorage.getItem('activeMegaMenuItem');
  if (activeItemHref) {
    document.querySelectorAll('.mega-menu-item').forEach(item => {
      if (item.href === activeItemHref) {
        item.classList.add('active');
      }
    });
  }
});